import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c6424c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M9.84301 0.5H4.15553C4.15553 0.5 3.44415 0.5 3.44415 1.375H10.5544C10.5544 0.5 9.84301 0.5 9.84301 0.5ZM11.9764 3.125C11.9764 2.25 11.2658 2.25 11.2658 2.25H2.73348C2.73348 2.25 2.02281 2.25 2.02281 3.125V4H11.9764V3.125ZM13.3978 4L12.9778 3.482V4.875H1.02145V3.482L0.600761 4C0.180074 4.518 -0.121335 4.65625 0.0479397 5.75C0.2165 6.84025 1.03288 12.8165 1.1543 13.625C1.28714 14.5122 2.02352 14.5 2.02352 14.5H11.9772C11.9772 14.5 12.7128 14.5122 12.8464 13.625C12.9678 12.8165 13.7835 6.84025 13.9527 5.75C14.1206 4.65625 13.8192 4.518 13.3978 4ZM9.85658 9.24737C9.85658 9.73212 9.53589 10.125 9.1402 10.125H4.85905C4.66906 10.125 4.48684 10.0325 4.35249 9.86794C4.21815 9.70336 4.14267 9.48013 4.14267 9.24737V7.5H4.85691V9.24999H9.14234V7.5H9.85658V9.24737Z",
    fill: "#475569"
  })
], -1))

import Button from "primevue/button";

export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveButton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), { severity: "secondary" }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})